// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"af3c618e","96":"17e6ef0d","337":"c5dfde20","471":"d30f0e5c","660":"b9aec0f3","732":"305c4071"}[chunkId] + ".chunk.js";
};